import { ActionRow } from '@/features/actions/components/action-row/ActionRow'
import { ActionRowBaseProps } from '@/features/actions/components/action-row/types'
import { BridgeAction } from './types'

interface BridgeActionRowProps extends ActionRowBaseProps {
  action: BridgeAction
}

export function BridgeActionRow({ action, ...props }: BridgeActionRowProps) {
  const title = `Bridge ${action.from.token.symbol} to ${action.to.token.symbol}`

  return (
    <ActionRow index={props.index}>
      <ActionRow.Title actionStatus={props.actionHandlerState.status}>{title}</ActionRow.Title>
      <ActionRow.Description 
        successMessage="Bridge complete"
        actionStatus={props.actionHandlerState.status}
        variant={props.variant}
      />
      <ActionRow.ErrorWarning 
        variant={props.variant} 
        actionHandlerState={props.actionHandlerState}
      />
      <ActionRow.Action 
        status={props.actionHandlerState.status}
        onAction={props.onAction}
      >
        Bridge
      </ActionRow.Action>
    </ActionRow>
  )
} 